export const INPUT_NUMBER = 'INPUT_NUMBER';
export const PLUS = 'PLUS';